module.exports = __webpack_public_path__ + "img/placeholder.30897d1e.jpg";